import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Type } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "jalali-moment";
import { LayoutService } from "projects/sepidz-web-framework/src/lib/@core/utils";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { NotificationModel } from "projects/sepidz-web-framework/src/lib/models/notification-model";
import { BookMarkMenu } from "projects/sepidz-web-framework/src/lib/models/usersetting.model";
import {
  AccountService,
  AppTranslationService,
  AuthService,
  ConfigurationService,
  CorrectYeKeService,
  HttpCommonService,
  LocalStoreManager,
  ShowToastrService,
} from "projects/sepidz-web-framework/src/lib/services";
import { AnalyticsService } from "projects/sepidz-web-framework/src/lib/services/analytics.service";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { IndexedDbService } from "projects/sepidz-web-framework/src/lib/services/indexed-db.service";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { Observable, Subject, Subscription } from "rxjs";
import { debounceTime, delay, take, takeUntil, tap } from "rxjs/operators";
import { ItemBranch, StockInWebKind } from "src/app/frontoffice/catalog/model/item.model";
import { DriverAssignmentComponent } from "src/app/frontoffice/driverassignment/driverassignment.component";
import { ExternalNotificationKindEnum } from "src/app/frontoffice/driverassignment/external-notification.model";
import { InvDailyWarehouse } from "src/app/frontoffice/inv/model/inv-daily-warehouse.model";
import { LocalSetting } from "src/app/frontoffice/local-setting/local-setting-model";
import { OrderItem, OrderItemCategory } from "src/app/frontoffice/order/model/orderItemcategory.model";
import { OrderPageComponent } from "src/app/frontoffice/order/orderpage/orderpage.component";
import { DashboardComponent } from "src/app/frontoffice/review/dashboard/dashboard.component";
import { SaleMethodBranchModel } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { ResetPasswordComponent } from "src/app/gnr/resetpassword/resetpassword.component";
import { MenuService } from "../../../../../../../src/app/pages/pages-menu";
import { DialogType } from "../../../../../../sepidz-web-framework/src/lib/models/dialog.enum";
import { CurrentBranchFormComponent } from "../../../current-branch/current-branch-form/current-branch-form.component";
import { ITab, TabularService } from "../../../tabular/tabular.service ";
import { backUpComponent } from "./backup/backUp.component";
import { CallinfoComponent } from "./callinfo/callinfo.component";
import { DelinoNotificationComponent } from "./delino-newOrder-notification/delino-notification.component";
import { ImportAndExportComponent } from "./importandexport/importexport.component";
import { UpdateWebAppComponent } from "./update-web-app/update-web-app.component";
import { TranslateService } from "@ngx-translate/core";
type DelinoIgnoredNotifyType = { count: number; branchId: number; branchTitle: string };

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() position = "normal";
  @Output() onStateChange: EventEmitter<any> = new EventEmitter<any>();
  DateString: string;
  TimeString: string;
  UserEnterTime: string;
  showDesk: boolean;
  userAvatar: string;
  isFullScreen: boolean = false;
  fleetConnection: boolean = true;
  smartConnection: boolean = true;
  delinoConnection: boolean = true;
  hasAccessOnlineFactor: boolean = false;
  showOnlineInvoice: boolean = false;
  inputEditorform: Type<any>;
  hasOrderOnline: boolean = false;
  ngUnsubscribe = new Subject<boolean>();
  elem: any;
  user: any;
  currentInformation = this.authService?.currentInformation();
  currentBranch = this.authService.currentBranch;
  isCallCenter =
    !!this.currentInformation?.RestaurantCallCenter ||
    !!this.currentInformation?.BranchingAdvancedEnabled ||
    !!this.currentInformation?.BranchingLightEnabled;

  timeLeft: number = 60;
  interval;
  _IsShowAction: boolean = false;
  _IsShowSeting: boolean;
  _IsShowNotifications: boolean = false;
  _IsShowTheme: boolean;
  today: number = Date.now();
  currentLanguage: any;
  SoftWareLicenseKind = SoftWareLicenseKind;
  menu = this.menuService.MENU_ITEMS;
  displayName = "";

  delinoIgnoredOrdersInfos: DelinoIgnoredNotifyType[] = [];
  fleetNotificationCount: number = 0;

  private pushSubscription: Subscription;
  private receiveOnlineInvoice: boolean;
  linkPaymentConnection = true;
  hasAnyDelinoSaleMethodBranch: boolean;

  delinoDialogIsOpened = false;
  audio: HTMLAudioElement;
  audioInitialized: boolean;

  get fiscalYear(): number {
    return this.authService?.currentFiscalYear?.Year;
  }

  constructor(
    public authService: AuthService,
    public indexedDbService: IndexedDbService,
    private layoutService: LayoutService,
    private analyticsService: AnalyticsService,
    private configurationService: ConfigurationService,
    private dialogService: SimpleModalService,
    private misSetupService: MisSetupService,
    private sts: ShowToastrService,
    private tabsservice: TabularService,
    private translationService: AppTranslationService,
    private storage: LocalStoreManager,
    private httpCommonService: HttpCommonService,
    private router: Router,
    private menuService: MenuService,
    private notification: NotificationService,
    private translate: TranslateService,
    protected commmon: CommonService,
    protected accountservice: AccountService,
    protected cd: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any
  ) {
    this.displayName = authService.currentUser?.DisplayName;
  }
  ngOnInit() {
    this.currentLanguage = this.translationService.languageList;
    const m = moment();
    this.startTimer();
    this.DateString = m.locale("fa").format("YYYY/MM/DD");
    this.TimeString = m.locale("fa").format("HH:mm");
    this.changeDirection();
    this.getUserAvatar();
    if (this.authService.currentUser) this.user = this.authService.currentUser;
    else this.user = "";
    this.elem = this.document.documentElement;
    this.misSetupService.source$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && x.length > 0)
        if (this.misSetupService.getboolean("SALE", "FullScreenView") == true) {
          this.isFullScreen = true;
          this.fullScreen();
        }
    });
    this.getLocalSetting();
    this.GetFirstLogin();
    this.init();
    this.getNotifications();
    const info = this.authService.currentInformation();
    const isLight = info.SepidzWebKind === SoftWareLicenseKind.RestaurantLightWeb;
    if (!isLight) {
      this.loadWareHouseStockItems()
        .pipe(take(1), delay(2000))
        .subscribe((res) => {
          this.indexedDbService.put("FrontOffice", "InvDaily", res).then();
        });
    }
    this.HealthCheckDelino(false);
    this.loadLeaflet();
    if (this.currentInformation?.PaymentPanelAVA) this.HealthCheckClub(true, false);
  }

  public ngOnDestroy(): void {
    if (this.pushSubscription && !this.pushSubscription.closed) this.pushSubscription.unsubscribe();
    if (this.ngUnsubscribe && !this.ngUnsubscribe.closed) this.ngUnsubscribe.unsubscribe();
    if (this.interval) this.pauseTimer();
  }

  public fullScreen(): void {
    if (this.isFullScreen) this.openFullscreen();
    else this.closeFullscreen();
  }

  public stateChange(): void {
    this.onStateChange.emit();
  }

  //TODO Where is it used??
  public toggleSidebar(): boolean {
    this.layoutService.changeLayoutSize();
    return false;
  }

  //TODO Where is it used??
  public toggleSettings(): boolean {
    return false;
  }

  //TODO Where is it used??
  public startSearch(): void {
    this.analyticsService.trackEvent("startSearch");
  }

  //TODO Where is it used??
  public changeTheme(themeName: string): void {
    this.configurationService.theme = themeName;
  }

  //TODO Where is it used??
  public closeNotification(): void {
    if (this._IsShowNotifications) this._IsShowNotifications = false;
  }

  public closeSetting(): void {
    if (this._IsShowSeting) this._IsShowSeting = false;
  }

  public closeAction(): void {
    if (this._IsShowAction) this._IsShowAction = false;
  }

  public branchSelect(): void {
    this.dialogService.open(CurrentBranchFormComponent, { autoFocus: true }).pipe(take(1)).subscribe();
  }

  public showNotification() {
    let menu = <ITab>{
      title: this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.DedicatedCourier"),
      isCloseable: true,
      active: true,
      responsive: true,
      data: [],
      componentType: DriverAssignmentComponent,
      hasbadge: false,
    };
    this.tabsservice.open(menu);
  }

  public setTheme(theme: string): void {
    this.commmon.setTheme(theme);
    this.commmon.updateSettings();
  }

  public updateDialog(): void {
    this.dialogService
      .open(UpdateWebAppComponent, { group: null }, { closeOnClickOutside: false })
      .pipe(take(1))
      .subscribe((model) => {});
  }

  public closeTheme(): void {
    if (this._IsShowTheme) this._IsShowTheme = false;
  }

  public changeDirection(direction?: any): void {
    if (!direction) return;
    this.commmon.LocalSetting.Language = direction.value;
    this.commmon.LocalSetting.Isrtl = direction.dir;
    this.httpCommonService
      .get(`Home/SetCulture/${direction.value}`)
      .pipe(take(1))
      .subscribe((data) => {});
    this.translationService.changeLanguage(direction.value);
    this.commmon.setDirection(direction.dir);
    this.commmon.updateSettings();
    this._IsShowSeting = false;
  }

  public closeSystem(): void {
    this.sts.showDialog(
      this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.DoWantExitSoftware"),
      this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Attention"),
      DialogType.confirm,
      () => {
        this.httpCommonService.create(`Authorization/Logout`, null).pipe(take(1)).subscribe();
        this.tabsservice.closeAllForce();
        this.router.navigate(["auth/logout"]);
        this.notification.stop();
      }
    );
  }

  public getNotifications(): void {
    type Notification = { Kind: number; ReferenceId: number; ImportanceLevel: number; BranchTitle: string };

    this.httpCommonService
      .get("ExternalNotification/GetAllNotificationByKindCheck")
      .pipe(take(1))
      .subscribe({
        next: (res: Notification[]) => {
          const fleetNotify = res.filter((x) => x.Kind == ExternalNotificationKindEnum.Fleet);
          this.fleetNotificationCount = fleetNotify.length;
          const delinoNotify = res.filter((x) => x.Kind == ExternalNotificationKindEnum.Delino && x.ImportanceLevel > 0);
          if (delinoNotify.length) {
            this.delinoIgnoredOrdersInfos = groupBy(delinoNotify, "ReferenceId");
            function groupBy(value: Notification[], field: string): DelinoIgnoredNotifyType[] {
              const groupedObj: { [key: string]: Notification[] } = value.reduce((prev, cur) => {
                if (!prev[cur[field]]) prev[cur[field]] = [cur];
                else prev[cur[field]].push(cur);
                return prev;
              }, {});
              return Object.keys(groupedObj).map((key) => ({
                branchId: +key,
                count: groupedObj[key][0].ImportanceLevel,
                branchTitle: groupedObj[key][0].BranchTitle,
              }));
            }
          }
          this.cd.markForCheck();
        },
      });
  }

  public openTab(item: BookMarkMenu): void {
    let level1: any;
    let level2: any;
    let level3: any;
    let level4: any;
    let openLevel: any;
    if (item.selectedMenu) {
      level1 = this.menu.find((f) => CorrectYeKeService.getCorrectYeKe(f.title) === CorrectYeKeService.getCorrectYeKe(item.selectedMenu));
    }
    if (item.selectedMenu1) {
      level2 = level1.children.find((f) => CorrectYeKeService.getCorrectYeKe(f.title) === CorrectYeKeService.getCorrectYeKe(item.selectedMenu1));
    }
    if (item.selectedMenu2) {
      level3 = level2.children.find((f) => CorrectYeKeService.getCorrectYeKe(f.title) === CorrectYeKeService.getCorrectYeKe(item.selectedMenu2));
    } else {
      level3 = level2.children.find((f) => CorrectYeKeService.getCorrectYeKe(f.title) === CorrectYeKeService.getCorrectYeKe(item.title));
    }
    if (item.selectedMenu3 && level3.children) {
      level4 = level3?.children?.find((f) => CorrectYeKeService.getCorrectYeKe(f.title) === CorrectYeKeService.getCorrectYeKe(item.selectedMenu3));
    } else {
      level4 =
        level3.children ??
        level3?.children?.find((f) => CorrectYeKeService.getCorrectYeKe(f.title) === CorrectYeKeService.getCorrectYeKe(item.title));
    }
    var datatrasfer: Datatransfer = <Datatransfer>{};
    openLevel = level4 ? level4 : level3;
    if ((openLevel === level3 && level3?.children?.length > 0) || openLevel?.hidden) {
      this.sts.showDialog(
        this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.ModuleDisabled"),
        this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Attention"),
        DialogType.confirm,
        () => {
          const findIdex = this.commmon?.LocalSetting?.BookMarkMenu?.findIndex(
            (f) => f.title === item.title && f.CreatedUserId == item.CreatedUserId
          );
          this.commmon?.LocalSetting?.BookMarkMenu?.splice(findIdex, 1);
          this.commmon.setLocalSetting();
        }
      );
      return;
    }
    if (openLevel?.children && openLevel?.children?.length > 0) openLevel = openLevel.children[0];
    if (openLevel) {
      const menu = <ITab>{
        title: openLevel.title,
        isCloseable: true,
        icon: openLevel.icon,
        active: true,
        responsive: true,
        componentType: openLevel.data,
        //modulePath: openLevel.target,
        data: [
          { provide: EntityBase, useValue: null },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: openLevel.VoucherKindId } },
        ],
      };
      const hasPermission = this.accountservice.userHasPermission(!openLevel.title ? openLevel.title : openLevel.apiName, openLevel.actionName);
      if (hasPermission) this.tabsservice.open(menu);
      else {
        this.sts.showDialog(
          this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.NotAccessModule"),
          this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Attention")
        );
      }
      this.showDesk = false;
    } else {
      const findIdex = this.commmon?.LocalSetting?.BookMarkMenu?.findIndex((f) => f.title === item.title && f.CreatedUserId === item.CreatedUserId);
      this.commmon?.LocalSetting?.BookMarkMenu?.splice(findIdex, 1);
    }
  }

  public ShowCallInfo(): void {
    this.dialogService.open(CallinfoComponent, { errorMessage: "NotFound!!!" }, { closeOnClickOutside: false, autoFocus: true, closeOnEscape: true });
  }

  public showPasswordForm(): void {
    this.dialogService.open(
      ResetPasswordComponent,
      { errorMessage: "NotFound!!!" },
      { closeOnClickOutside: false, autoFocus: true, closeOnEscape: true }
    );
  }

  public HealthCheckClub(isLink: boolean, showDialog = true): void {
    const branchId = this.accountservice.authService.currentBranchId;
    const url = `Invoice/HealthCheckClub/${branchId}`;
    this.httpCommonService
      .getList(url)
      .pipe(take(1))
      .subscribe({
        next: (data: number) => {
          this.commmon.smartConnection = data > 0;
          this.linkPaymentConnection = data > 0;
          this.smartConnection = data > 0;
          if (showDialog) {
            if (isLink) {
              if (data > 0)
                this.sts.showDialog(
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.PaymentLinkConnected"),
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Message")
                );
              else
                this.sts.showDialog(
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.ErrorOccurredConnectPaymentLink"),
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error")
                );
            } else {
              if (data > 0)
                this.sts.showDialog(
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.CommunicationCustomerClubEstablished"),
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Message")
                );
              else
                this.sts.showDialog(
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.ErrorCommunicatingCustomerClub"),
                  this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error")
                );
            }
          }
        },
      });
  }

  public fleetConnectionTest(): void {
    const url = `Personnel/FleetConnectionTest`;
    this.httpCommonService
      .getList(url)
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          this.fleetConnection = data;
          if (data)
            this.sts.showDialog(
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.CommunicationFleetEstablished"),
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Message")
            );
          else
            this.sts.showDialog(
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.ErrorCommunicatingFleet"),
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error")
            );
        },
      });
  }
  public HealthCheckDelino(showDialog = true): void {
    const branchId = this.accountservice.authService.currentBranchId;
    const url = `Delino/HealthCheckDelino?branchCode=` + branchId;
    this.httpCommonService
      .get(url)
      .pipe(take(1))
      .subscribe((res: { delinoConnection: boolean; hasAnyDelinoSaleMethodBranch: boolean }) => {
        this.hasAnyDelinoSaleMethodBranch = res.hasAnyDelinoSaleMethodBranch;
        this.delinoConnection = res.delinoConnection;
        if (showDialog) {
          if (this.delinoConnection)
            this.sts.showDialog(
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.CommunicationDelinoEstablished"),
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Message")
            );
          else
            this.sts.showDialog(
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.CommunicationDelinoNotEstablished"),
              this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error")
            );
        }
        this.cd.markForCheck();
      });
  }

  public ImportAndExport(): void {
    this.dialogService.open(ImportAndExportComponent, { group: null }, { closeOnClickOutside: false }).pipe(take(1)).subscribe();
  }

  public openBackUpDialog(): void {
    this.dialogService.open(backUpComponent, { group: null }, { closeOnClickOutside: false }).pipe(take(1)).subscribe();
  }

  public showDelino(branchId: number) {
    this.httpCommonService
      .get("SaleMethodBranch/GetDelinoSaleMethodBranch?BranchId=" + branchId)
      .pipe(take(1))
      .subscribe((data: SaleMethodBranchModel) => {
        const index = this.delinoIgnoredOrdersInfos.findIndex((x) => x.branchId === branchId);
        if (index !== -1) this.delinoIgnoredOrdersInfos.splice(index, 1);
        this.setEmptyDelinoNotif(branchId);
        if (!data) return;

        let saleMethodTitleName = data.SaleMethodTitle;
        let menu = <ITab>{
          title: saleMethodTitleName,
          isCloseable: true,
          icon: "{ icon: 'dashboard', pack: 'sepidzicon' }",
          active: true,
          responsive: true,
          data: [{ provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: data.Id, orderOnlinePage: true } }],
          componentType: OrderPageComponent,
          hasbadge: false,
        };
        const onlineOrderTabIndex = this.tabsservice.tabItemSubject.value?.findIndex(
          (x) => x.data?.find((z) => z.useValue?.orderOnlinePage) || x.title === saleMethodTitleName
        );
        if (onlineOrderTabIndex > -1) {
          this.tabsservice.tabItemonRefreshData.next("Delino");
          this.tabsservice.setSelectedTab(onlineOrderTabIndex);
        } else {
          this.tabsservice.open(menu);
        }
        this.cd.markForCheck();
      });
  }

  private init(): void {
    this.notification.init();
    this.pushSubscription = this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      this.handleNotifyAction(value);
    });
  }

  private handleNotifyAction(value: NotificationModel): void {
    const currentInfo = this.accountservice.authService.currentInformation();
    switch (value.Key) {
      case "fleetConnection":
        this.fleetConnection = value.Message ?? false;
        if (!currentInfo.SafirCourierFleetManagement) this.fleetConnection = false;
        break;
      case "smartConnection":
        this.smartConnection = value.Message ?? false;
        if (!currentInfo.SmartEvaluation) this.smartConnection = false;
        break;
      case "DelinoConnection":
        this.delinoConnection = value.Message ?? false;
        this.cd.detectChanges();
        break;
      case "DelinoAutoAcceptFactor": // auto
        this.handleAutoDelinoFactor(value);
        break;
      case "UpdateVersion": // auto
        this.updateVersion(value.Message);
        break;
      case "DelinoHasOrder": //manual
        this.handleDelinoNotify(value);
        break;
      case "AcceptMissionTimeOut": //manual
        this.sts.showToast(
          "warning",
          `${this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.InvoiceNumber")} ${value.Message}  ${this.translate.instant(
            "ClientApp.Projects.FrameWorkShell.Header.NotConfirmedCourier"
          )} `,
          null,
          200000
        );
        break;
      case "VehicleHelpMessage": //manual
        this.sts.showToast(
          "warning",
          `${this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Driver")} *${value.Message}* ${this.translate.instant(
            "ClientApp.Projects.FrameWorkShell.Header.SupportRequest"
          )}`,
          null,
          200000
        );
        break;
      case "LinkPaymentConnection":
        this.linkPaymentConnection = value.Message ?? false;
        if (!currentInfo.PaymentPanelAVA) this.linkPaymentConnection = false;
        this.commmon.smartConnection = this.linkPaymentConnection;
        break;
      case "UpdateWareHouseStock":
        const info = this.authService.currentInformation();
        const isLight = info.SepidzWebKind === SoftWareLicenseKind.RestaurantLightWeb;
        if (isLight) return;
        this.updateWareHouseStockItems(value);
        break;
      case "LocalSettingHasChanges":
        this.getLocalSetting(false);
        break;
      case "NewNotification":
        this.getNotifications();
        break;
    }
  }
  updateVersion(msg: boolean) {
    if (msg === true) {
      this.storage.clearAllStorage();
      window.location.reload();
    }
  }

  private handleDelinoNotify(value: NotificationModel): void {
    const hasAnyShowOnlineInvoiceSetting = value.Message?.hasAnyShowOnlineInvoice;
    const canShowDelinoNotify = hasAnyShowOnlineInvoiceSetting ? this.showOnlineInvoice : true;
    if (
      canShowDelinoNotify &&
      this.delinoConnection &&
      ((this.isCallCenter && this.currentBranch.AccessToAllBranches) || value.Message.branchId == this.accountservice.authService.currentBranchId)
    ) {
      this.increasingTheNumberOfDelinoNotifications(value.Message.branchId);
      this.playSound();
      this.cd.markForCheck();
      if (this.delinoDialogIsOpened) return;
      this.delinoDialogIsOpened = true;
      this.dialogService
        .open(
          DelinoNotificationComponent,
          { errorMessage: "NotFound!!!", branchId: value.Message.branchId },
          { closeOnClickOutside: false, autoFocus: true, closeOnEscape: true }
        )
        .pipe(
          take(1),
          tap((x) => {
            this.delinoDialogIsOpened = false;
            if (x) {
              this.delinoIgnoredOrdersInfos = this.delinoIgnoredOrdersInfos.filter((x) => x.branchId !== value.Message.branchId);
              this.cd.markForCheck();
            }
          }),
          delay(2000)
        )
        .subscribe((x) => {
          if (x) this.setEmptyDelinoNotif(value.Message.branchId);
        });
    }
  }

  private increasingTheNumberOfDelinoNotifications(branchId: number): void {
    const info = this.delinoIgnoredOrdersInfos.find((x) => x.branchId == branchId);
    if (info) info.count++;
    else {
      const info: DelinoIgnoredNotifyType = { branchId, count: 1, branchTitle: "" };
      this.delinoIgnoredOrdersInfos.push(info);
    }
    this.httpCommonService
      .create("ExternalNotification/IncreasingDelinoNotif?ReferenceId=" + branchId, {})
      .pipe(take(1))
      .subscribe((x) => {});
  }

  private setEmptyDelinoNotif(branchId: number): void {
    this.httpCommonService
      .put("ExternalNotification/SetEmptyDelinoNotif?ReferenceId=" + branchId, {})
      .pipe(take(1))
      .subscribe((x) => {});
  }

  private handleAutoDelinoFactor(value: NotificationModel): void {
    if (this.receiveOnlineInvoice && this.delinoConnection) {
      this.sts.showToast("success", this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.NewOrderDelino"), null, 7000);
      this.httpCommonService
        .get("SaleMethodBranch/GetDelinoSaleMethodBranch?BranchId=" + value.Message.BranchId)
        .pipe(take(1))
        .subscribe((data: SaleMethodBranchModel) => {
          const saleMethodDelinoId = data.Id;
          const onlineOrderTabIndex = this.tabsservice.tabItemSubject?.value?.findIndex(
            (x) => x.data?.find((z) => z.useValue?.orderOnlinePage) || x.title === data?.SaleMethodTitle
          );
          if (onlineOrderTabIndex > -1) {
            const id = value.Message.Id;
            this.tabsservice.tabItemonRefreshData.next("DelinoFactorId:" + id);
          } else {
            let menu = <ITab>{
              title: data.SaleMethodTitle,
              isCloseable: true,
              icon: "{ icon: 'dashboard', pack: 'sepidzicon' }",
              active: true,
              responsive: true,
              data: [
                {
                  provide: VoucherKindInfo,
                  useValue: <VoucherKindInfo>{ VoucherKindId: saleMethodDelinoId, orderOnlinePage: true, autoDelinoInvoiceId: value.Message.Id },
                },
              ],
              componentType: OrderPageComponent,
              hasbadge: false,
            };
            this.tabsservice.open(menu);
          }
        });
    }
  }

  private getLocalSetting(firstCall = true): void {
    const computerName: string = this.commmon.storage.getData(ClearableCache.ComputerName);
    this.httpCommonService
      .get("LocalSetting/GetLocalSetting" + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(
        take(1),
        tap((data: LocalSetting[]) => {
          this.commmon.storage.savePermanentData(data, ClearableCache.LocalSetting);
          if (data.length) {
            this.showOnlineInvoice = data.some((x) => x.ShowOnlineInvoice);
            this.receiveOnlineInvoice = data.some((x) => x.ReceiveOnlineInvoice);
          } else {
            this.showOnlineInvoice = false;
            this.receiveOnlineInvoice = false;
          }
        }),
        delay(500)
      )
      .subscribe(() => {
        this.currentBranch = this.authService.currentBranch;
        if (
          !this.currentBranch.NoDisplayDashboard &&
          this.currentInformation.SepidzWebKind !== SoftWareLicenseKind.RestaurantLightWeb &&
          !this.commmon.isMobileMode &&
          firstCall
        ) {
          let menu = <ITab>{
            title: "ClientApp.Pages.Dashboard",
            isCloseable: true,
            icon: "{ icon: 'dashboard', pack: 'sepidzicon' }",
            active: true,
            responsive: true,
            data: [],
            componentType: DashboardComponent,
            hasbadge: false,
          };
          this.tabsservice.open(menu);
        }
        this.cd.detectChanges();
      });
  }

  private GetFirstLogin(): void {
    const url = `Authorization/GetFirstLogin/${this.authService.currentUser?.Id}`;
    this.httpCommonService
      .get(url)
      .pipe(take(1))
      .subscribe((data: string) => {
        const [hour, minute] = data.split(":").map(Number);
        const formattedHour = hour < 10 ? "0" + hour : hour;
        const formattedMinute = minute < 10 ? "0" + minute : minute;
        this.UserEnterTime = `${formattedHour}:${formattedMinute}`;
        this.cd.markForCheck();
      });
  }

  openImageUpload(fileToUpload: any): boolean {
    if (fileToUpload.target.files && fileToUpload.target.files[0]) {
      const max_size = 300000;
      const max_height = 512;
      const max_width = 512;

      if (fileToUpload.target.files[0].size > max_size) {
        let error =
          this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.UploadedImageSizeLessThan") +
          max_size / 1000 +
          this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.BeKb");
        this.sts.showDialog(error, this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error"));
        return false;
      }
      const formData = new FormData();
      formData.append("photo", fileToUpload.target.files[0]);
      formData.append("userId", this.authService.currentUser?.Id.toString());
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let image = new Image();
        image.src = e.target.result;
        image.onload = (rs: any): any => {
          const img_height = rs.currentTarget["height"];
          const img_width = rs.currentTarget["width"];
          if (img_height > max_height || img_width > max_width) {
            let error = this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.ImageSizeNotAllowed");
            this.sts.showDialog(error, this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error"));
            return false;
          } else {
            this.httpCommonService
              .upload("Personnel/UploadPhotoByUserId", formData)
              .pipe(take(1))
              .subscribe({
                next: (response: any) => {
                  this.userAvatar = response.imagePath + this.getRandom();
                  this.cd.markForCheck();
                },
                error: (err) =>
                  this.sts.showDialog(
                    this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.ErrorLoadingImage"),
                    this.translate.instant("ClientApp.Projects.FrameWorkShell.Header.Error")
                  ),
              });
          }
        };
      };
      reader.readAsDataURL(fileToUpload.target.files[0]);
    }
  }

  getRandom() {
    return "?" + new Date().getTime();
  }

  private getUserAvatar(): void {
    const url = "Personnel/GetPersonnelPhoto/" + this.authService.currentUser?.Id;
    this.httpCommonService
      .get(url)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response != null && response.imagePath != null) {
            this.userAvatar = response.imagePath;
          }
        },
      });
  }

  private startTimer(): void {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 60;
        this.pauseTimer();
        this.refreshTime();
        this.startTimer();
      }
    }, 1000);
  }

  private refreshTime(): void {
    const m = moment();
    this.TimeString = m.locale("fa").format("HH:mm");
  }

  private pauseTimer(): void {
    clearInterval(this.interval);
  }

  private openFullscreen(): void {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem["mozRequestFullScreen"]) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem["webkitRequestFullscreen"]) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem["msRequestFullscreen"]) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  private closeFullscreen(): void {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }

  private updateWareHouseStockItems(value: NotificationModel) {
    const onlineOrderTabIndex = this.tabsservice.tabItemSubject.value.findIndex((x) => x.componentType.name === "OrderPageComponent");
    if (onlineOrderTabIndex === -1) {
      this.indexedDbService.get("FrontOffice", "InvDaily").then((data) => {
        if (data) {
          (value.Message?.goodsInfo as InvDailyWarehouse[]).forEach((newInfo) => {
            let goodsInfo = data.find((x) => x.GoodsId == newInfo.GoodsId && x.BranchId === this.accountservice.authService.currentBranchId);
            if (goodsInfo) {
              goodsInfo.Amount = newInfo.Amount;
              goodsInfo.MinAmount = newInfo.MinAmount;
              goodsInfo.WasteAmount = newInfo.WasteAmount;
              goodsInfo.PrevRemainAmount = newInfo.PrevRemainAmount;
              goodsInfo.EntryAmount = newInfo.EntryAmount;
              goodsInfo.CancelAmount = newInfo.CancelAmount;
              goodsInfo.SaleAmount = newInfo.SaleAmount;
            } else data.push(newInfo);
          });
          this.indexedDbService.put("FrontOffice", "InvDaily", data).then();
          this.updateStockInWebByInvSignal(this.accountservice.authService.currentBranchId, data, value.Message?.eventName);
        } else {
          this.loadWareHouseStockItems()
            .pipe(take(1))
            .subscribe((res) => {
              (value.Message?.goodsInfo as InvDailyWarehouse[]).forEach((newInfo) => {
                let goodsInfo = res.find((x) => x.GoodsId == newInfo.GoodsId && x.BranchId === this.accountservice.authService.currentBranchId);
                if (goodsInfo) {
                  goodsInfo.Amount = newInfo.Amount;
                  goodsInfo.MinAmount = newInfo.MinAmount;
                  goodsInfo.WasteAmount = newInfo.WasteAmount;
                  goodsInfo.PrevRemainAmount = newInfo.PrevRemainAmount;
                  goodsInfo.EntryAmount = newInfo.EntryAmount;
                  goodsInfo.CancelAmount = newInfo.CancelAmount;
                  goodsInfo.SaleAmount = newInfo.SaleAmount;
                } else res.push(newInfo);
              });
              this.indexedDbService.put("FrontOffice", "InvDaily", res).then();
              this.updateStockInWebByInvSignal(this.accountservice.authService.currentBranchId, res, value.Message?.eventName);
            });
        }
      });
    }
  }

  private loadWareHouseStockItems(): Observable<InvDailyWarehouse[]> {
    const branchId = this.authService.localStorage.getData("BranchId");
    return this.httpCommonService.get<InvDailyWarehouse[]>("Invoice/GetWarehouseStockItems?branchId=" + branchId);
  }

  updateStockInWebByInvSignal(branchId: number, warehouseStockItems: InvDailyWarehouse[], eventName: string) {
    this.indexedDbService.get("FrontOffice", "Categories").then((allCategories) => {
      if (allCategories) {
        this.updateItems(allCategories, branchId, warehouseStockItems, eventName);
      } else {
        const computerName: string = this.commmon.storage.getData(ClearableCache.ComputerName);
        this.httpCommonService
          .get("ItemCategory/GetOrderItemCategory" + (computerName ? "?ComputerName=" + computerName : ""))
          .pipe(take(1))
          .subscribe((data: OrderItemCategory[]) => {
            this.indexedDbService.put("FrontOffice", "Categories", data).then();
            this.updateItems(data, branchId, warehouseStockItems, eventName);
          });
      }
    });
  }

  private updateItemNotAvailableGoodIds(BranchId: number, item: OrderItem, eventName: string) {
    const itemBranch = item.Branches.find((x) => x.BranchId === BranchId);
    if (
      item.notAvailableGoodIds?.length &&
      itemBranch &&
      (itemBranch.StockInWeb === StockInWebKind.Available || itemBranch.StockInWeb === StockInWebKind.UnAvailableOnSite)
    ) {
      itemBranch.StockInWeb = StockInWebKind.UnAvailableFromInv;
      item.StockInWeb = StockInWebKind.UnAvailableFromInv;
    } else if (
      !item.notAvailableGoodIds?.length &&
      itemBranch &&
      itemBranch.StockInWeb !== StockInWebKind.Available &&
      (eventName !== "invoiceChanges" || itemBranch.StockInWeb !== StockInWebKind.UnAvailable)
    ) {
      itemBranch.StockInWeb = StockInWebKind.Available;
      item.StockInWeb = StockInWebKind.Available;
    }
  }

  private updateItems(allCategories: any, branchId: number, warehouseStockItems: InvDailyWarehouse[], eventName: string) {
    allCategories.forEach((ele) => {
      ele.Items.forEach((it) => {
        if (it.Branches?.length) {
          const usedGoodsInItem = warehouseStockItems?.filter(
            (f) => (f.PrevRemainAmount || f.EntryAmount) && f.BranchId === branchId && f.ItemsInRelation.some((x) => x.Id === it.Id)
          );
          it.notAvailableGoodIds = usedGoodsInItem.filter((x) => x.Amount <= 0).map((x) => x.GoodsId);
          if (usedGoodsInItem.length) this.updateItemNotAvailableGoodIds(branchId, it, eventName);
        } else {
          it.ItemChild?.forEach((child) => {
            const usedGoodsInItem = warehouseStockItems?.filter(
              (f) => (f.PrevRemainAmount || f.EntryAmount) && f.BranchId === branchId && f.ItemsInRelation.some((x) => x.Id === child.Id)
            );
            child.notAvailableGoodIds = usedGoodsInItem.filter((x) => x.Amount <= 0).map((x) => x.GoodsId);
            if (usedGoodsInItem.length) this.updateItemNotAvailableGoodIds(branchId, child, eventName);
          });
        }
      });
    });
  }

  private loadLeaflet(): void {
    if (this.currentInformation?.SafirCourierFleetManagement && !document.getElementById("leafletNeshan")) {
      const script = document.createElement("script");
      script.id = "leafletNeshan";
      script.src = "https://static.neshan.org/sdk/leaflet/1.4.0/leaflet.js";
      document.head.appendChild(script);

      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://static.neshan.org/sdk/leaflet/1.4.0/leaflet.css";
      document.head.appendChild(link);
    }
  }

  playSound() {
    const element: any = document.getElementById("bell");
    element.play();
  }
}
